module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "discounts"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.discountsAmount,
      "link": "link",
      "table-id": "discounts",
      "tableHeight": "calc(100% - 48px)"
    },
    on: {
      "refresh": _vm.getDiscounts,
      "create": _vm.addDiscount
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(scope) {
        return [_c('span', [_c('md-button', {
          staticClass: "md-icon-button md-dense small",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.discountIdToDelete = scope.item.id;
              _vm.deleteDialog = true;
            }
          }
        }, [_c('md-icon', [_vm._v("delete")])], 1), _c('md-tooltip', {
          attrs: {
            "md-direction": "top"
          }
        }, [_vm._v("Удалить скидку")])], 1)]
      }
    }]),
    model: {
      value: (_vm.discounts),
      callback: function($$v) {
        _vm.discounts = $$v
      },
      expression: "discounts"
    }
  }), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.deleteDialog,
      "md-title": "Удалить скидку?",
      "md-content": "Внимание! Действие необратимо!",
      "md-confirm-text": "Удалить",
      "md-cancel-text": "Отмена"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.deleteDialog = $event
      },
      "md-cancel": function($event) {
        _vm.deleteDialog = false;
        _vm.discountIdToDelete = null;
      },
      "md-confirm": _vm.deleteDiscount
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fe7f31e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/Discounts.vue
// module id = 1213
// module chunks = 0